import React from "react";
import { useTheme } from "styled-components";
import HeaderOneDesktop from "componentLayout/Header/HeaderOne/HeaderOneDesktop";
import HeaderTwoDesktop from "componentLayout/Header/HeaderTwo/HeaderTwoDesktop";
import HeaderThreeDesktop from "componentLayout/Header/HeaderThree/HeaderThreeDesktop";
import HeaderFourDesktop from "componentLayout/Header/HeaderFour/HeaderFourDesktop";
import FooterOneDesktop from "componentLayout/Footer/FooterOne/FooterOneDesktop";
import FooterTwoDesktop from "componentLayout/Footer/FooterTwo/FooterTwoDesktop";
import FooterThreeDesktop from "componentLayout/Footer/FooterThree/FooterThreeDesktop";
import FooterFourDesktop from "componentLayout/Footer/FooterFour/FooterFourDesktop";
import { ILayoutProps } from "components/Layouts/PageLayouts/CustomizedPageLayout/CustomizedPageLayout";
import { Footer, PageContent } from "./styles.styled";
import { useAppContext } from "contexts/AppContextProvider";
import { classNames } from "helpers/themeHelpers";
import dynamic from "next/dynamic";
import LazyLoadWindowScroll from "components/LazyLoadWindowScroll/LazyLoadWindowScroll";
import AdsBillBoardShimmer from "../../../../componentReusable/Ads/AdsBillBoard/AdsBillBoardShimmer";

const KsaDocuments = dynamic(
  () => import("componentLayout/Footer/ksaDocuments"),
  {
    suspense: false,
  }
);

const CustomizedPageLayoutDesktop = (props: ILayoutProps) => {
  const {
    children,
    enableH1,
    enableH2,
    enableH3,
    enableH4,
    enableF1,
    enableF2,
    enableF3,
    enableF4,
    supportBottomSticky = false,
    linkedAds,
  } = props;
  const { country } = useTheme();
  const { isWebView, isDarkMode } = useAppContext();
  return (
    <>
      {!isWebView && (
        <>
          {enableH1 && <HeaderOneDesktop />}
          {enableH2 && <HeaderTwoDesktop />}
          <header className="borderBottomLightGray">
            {/*header three desktop (Mega menu)*/}
            {enableH3 && <HeaderThreeDesktop />}
            {/*header Four desktop (Search)*/}
            {enableH4 && <HeaderFourDesktop />}
          </header>
        </>
      )}
      <PageContent
        id="pageContent"
        {...classNames("m-auto", !isWebView && "width-1200")}
      >
        {children}
      </PageContent>
      {country && !isWebView && (
        <Footer className="contentVisibilityHidden">
          {enableF4 && <FooterFourDesktop />}
          {linkedAds && linkedAds.includes("desktop_homepage_footer") && (
            <div style={{ height: "250px", maxWidth: "970px", margin: "auto" }}>
              <LazyLoadWindowScroll
                render={() => {
                  return (
                    <AdsBillBoardShimmer
                      adName="desktop_homepage_footer"
                      className="m-auto mt-8 mb-8 center"
                      style={{ maxWidth: "970px", height: "250px", margin: "auto" }}
                    />
                  );
                }}
              />
            </div>
          )}
          {linkedAds && linkedAds.includes("listingPageBottom-desktop") && (
            <div style={{ height: "250px", maxWidth: "970px", margin: "auto" }}>
              <LazyLoadWindowScroll
                render={() => {
                  return (
                    <AdsBillBoardShimmer
                      adName="listingPageBottom-desktop"
                      className="m-auto center pb-32"
                      style={{ maxWidth: "970px", height: "250px", margin: "auto" }}
                    />
                  );
                }}
              />
            </div>
          )}
          {linkedAds && linkedAds.includes("postviewBottom-desktop") && (
            <div style={{ height: "250px", maxWidth: "970px", margin: "auto" }}>
              <LazyLoadWindowScroll
                render={() => {
                  return (
                    <AdsBillBoardShimmer
                      adName="postviewBottom-desktop"
                      className="m-auto center pb-32"
                      style={{ maxWidth: "970px", height: "250px", margin: "auto" }}
                    />
                  );
                }}
              />
            </div>
          )}
          {enableF3 && <FooterThreeDesktop />}
          {enableF2 && <FooterTwoDesktop />}
          {enableF1 && <FooterOneDesktop />}
          {country && country === "sa" && <KsaDocuments />}
        </Footer>
      )}
    </>
  );
};

export default CustomizedPageLayoutDesktop;
